import { LinearProgress } from "@/components/progress";
import { Hobbie, Profession } from "../schema/relation-fields.schema";
import { NoData } from "@/components/common/section-components/NoData";
import { StandardTable } from "@/components/table/StandardTable";
import { relationFieldsTableHeaderElements } from "../schema/header-elements";
import { Dispatch, SetStateAction } from "react";
import { RelationFieldsActions } from "@/components/common/section-components/action/RelationFieldsActions";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "@/constants/routes";

interface Props {
  loadingQuery: boolean;
  sectionData?: Profession[];
  professionSelection: string[];
  noActions: boolean;
  noSelection: boolean;
  setProfessionSelection: Dispatch<SetStateAction<string[]>>;
}

export const ProfessionsTable = ({
  loadingQuery,
  sectionData,
  professionSelection,
  setProfessionSelection,
  noActions,
  noSelection,
}: Props) => {
  const navigate = useNavigate();
  const handleEdit = (item: Hobbie) => {
    navigate(AppRoutes.PROFESSION_EDIT.replace(":id", String(item?.id)));
  };

  const getActionElements = (item: Hobbie) => (
    <RelationFieldsActions handleEdit={handleEdit} item={item} />
  );

  return loadingQuery ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingQuery && Boolean(!sectionData?.length) ? (
        <NoData />
      ) : (
        <StandardTable
          headers={relationFieldsTableHeaderElements}
          items={sectionData || []}
          noActions={noActions}
          noSelection={noSelection}
          actionElements={getActionElements}
          actionsHeaderLabel="Edición"
          multipleSelection
          selection={professionSelection}
          setSelection={setProfessionSelection}
          noBorder
        />
      )}
    </>
  );
};
